import { LoadingProvider } from "./LoadingProvider";
import { LoginProvider } from "./LoginProvider";
import { ModalProvider } from "./ModalProvider";
import { Outlet } from "react-router";

export function AppContextProvider() {
  return (
    <LoginProvider>
      <LoadingProvider>
        <ModalProvider>
          <Outlet />
        </ModalProvider>
      </LoadingProvider>
    </LoginProvider>
  );
}
